import { EVENT_LISTENER_METHODS, eventBus } from '@cometchat/calls-sdk-core';
import { createRoot, type Root } from 'react-dom/client';
import CallScreen from '../ui/CallScreen.web.tsx';

let root: Root | null = null;

export function joinSessionInternal(container: HTMLElement) {
  if (root) {
    root.render(<CallScreen />);
  } else {
    root = createRoot(container);
    root.render(<CallScreen />);
  }
}

eventBus.subscribe(
  EVENT_LISTENER_METHODS.SessionStatusListener.onConnectionClosed,
  () => {
    setTimeout(() => {
      if (root) {
        root.unmount();
        root = null;
      }
    }, 0);
  },
);
